import React from "react"
import { Dialog, FlatButton, Toggle } from "material-ui"
import strings from "../../../localization/strings"
import { IScheduleDocument } from "../../../models"
import moment from "moment"
import { grey700 } from "material-ui/styles/colors"
import * as timeHelper from "../../../helpers/timeHelper"
interface IProps {
	schedule: IScheduleDocument
	close(): void
	handleAutoAssign(limitToShiftHierarchy: boolean): void
}
interface IState {
	limitToShiftHierarchy: boolean
}

export default class AutoAssignEmployeeConfirmDialog extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			limitToShiftHierarchy: true
		}
	}

	render() {
		return (
			<Dialog
				title={strings.Auto_Assign_Employees_to_Schedule}
				actions={[
					<FlatButton
						data-intercom-target={"AutoAssignEmployee-Btn-CloseAutoAssignEmployeeConfirmDialog"}
						label={strings.CANCEL}
						onClick={this.props.close}
					/>,
					<FlatButton
						data-intercom-target={"AutoAssignEmployee-Btn-AutoAssign"}
						label={strings.Auto_Assign.toUpperCase()}
						primary
						keyboardFocused
						onClick={() => this.props.handleAutoAssign(this.state.limitToShiftHierarchy)}
					/>,
				]}
				modal
				open
				onRequestClose={this.props.close}
			>
				<div style={{ marginTop: 20 }}>
					<div style={{ position: "absolute", top: 30, right: 50, fontWeight: 500 }}>
						{moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.StartDate)).format("ddd MMM. DD, YYYY")} &mdash; {moment(timeHelper.keepConvertUTCToLocal(this.props.schedule.EndDate)).format("ddd MMM. DD, YYYY")}
					</div>
					<Toggle
						data-intercom-target={"AutoAssignEmployee-Toggle-LimitToShiftHierarchy"}
						label={strings.Limit_To_Shift_Hierarchy}
						toggled={this.state.limitToShiftHierarchy}
						onToggle={(e, value) => this.setState({ limitToShiftHierarchy: value })}
						style={{ width: 250, marginBottom: 20 }}
					/>
					<div>
						{strings.Auto_Assign_Confirm_Dialog_Body}
					</div>
					<div style={{ marginTop: 10, color: grey700 }}>
						{`${this.props.schedule.Schedules.length} ${strings.Shifts}`}
					</div>
				</div>
			</Dialog>
		)
	}
}